module.exports = __webpack_public_path__ + "media/images/professioneel-209c441ce644ac3a123aded79f2451ca.jpg";